import React from 'react';
import PropTypes from 'prop-types';

const Declined = props => {
  const { color: _color, width: _width, height: _height, ...other } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...other}>
      <g id="グループ_4177" data-name="グループ 4177" transform="translate(-0.16 -0.5)">
        <circle id="楕円形_35" data-name="楕円形 35" cx="16" cy="16" r="16" transform="translate(0.16 0.5)" fill="#f2faff" />
        <g id="グループ_4220" data-name="グループ 4220" transform="translate(-1.84 2)">
          <circle id="楕円形_54" data-name="楕円形 54" cx="1.5" cy="1.5" r="1.5" transform="translate(10 13.5)" fill="#1aa7ff" />
          <circle id="楕円形_55" data-name="楕円形 55" cx="1.5" cy="1.5" r="1.5" transform="translate(16 13.5)" fill="#1aa7ff" />
          <circle id="楕円形_56" data-name="楕円形 56" cx="1.5" cy="1.5" r="1.5" transform="translate(22 13.5)" fill="#1aa7ff" />
        </g>
      </g>
    </svg>
  );
}

Declined.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Declined.defaultProps = {
  color: '#f2faff',
  width: 32,
  height: 32,
};

export default Declined;



// WEBPACK FOOTER //
// ./src/components/Icons/Declined.jsx